// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "vue2-google-maps" + "." + "2b86fefe" + ".css";
};